export default __webpack_public_path__ + "static/media/icon_fire_smoke_on.e4c59082.png";